module.exports = __webpack_public_path__ + "static/media/refurbishLaminateFloor.8a4d9a54.jpg";